import React from 'react'
/*import { useSelector, useDispatch } from 'react-redux'

import MainHeader from 'components/navigation/MainHeader'
import UnblockerContent from 'components/modules/products/unblocker/UnblockerContent'
import SubscriptionInfo from 'components/modules/settings/SubscriptionsInfo'

import { isSubscriptionActive } from 'utils/functions'
import { selectUserSubscriptionView } from 'store/user/selectors'
import { UserActionsTypes } from 'store/user/actions'
import { logAmplitudeEvent } from 'utils/analytics'*/
import { Navigate } from 'react-router-dom'

const ScrapingPage: React.FC = () => {
  return <Navigate to="/" replace />

  /*const dispatch = useDispatch()
  const crumbsItems = [
    {
      label: 'Overview',
      to: '/',
    },
    {
      label: 'Web Data API',
      isActive: true,
    },
  ]

  const subscriptionInfo = useSelector(selectUserSubscriptionView)

  const isUserSubscriptionActive = isSubscriptionActive(subscriptionInfo)
  const isDemoModeAvailable = !subscriptionInfo?.status

  useEffect(() => {
    if (isDemoModeAvailable) {
      logAmplitudeEvent('Web Data API product view')
    }
  }, [])

  useEffect(() => {
    if (isUserSubscriptionActive) {
      dispatch({ type: UserActionsTypes.USER_GET_SCRAPPER_API_KEY })
    }
  }, [dispatch, isUserSubscriptionActive])

  return (
    <>
      <MainHeader crumbsItems={crumbsItems} />
      {isSubscriptionActive(subscriptionInfo) || isDemoModeAvailable ? (
        <UnblockerContent />
      ) : (
        <SubscriptionInfo reducedDisplayMode />
      )}
    </>
  )*/
}

export default ScrapingPage
